import React, { useEffect, useState } from "react";
import { getReceipt } from "api/sales";
import { ReceiptContainer, Content, Divider, ReceiptRow, GridRow, Highlight } from "styles/components/home/ReceiptStyle";

const Receipt = ({sid}) => {
    const [receiptData, setReceiptData] = useState(null);

    const fetchReceiptData = async (sid) => {
        try {
          const res = await getReceipt(sid);
          setReceiptData(res?.data?.result);
        } catch (error) {
          alert(error);
        }
    };
      
    useEffect(() => {
        console.log(sid);
        fetchReceiptData(sid);
    }, [sid]);  

    const formatDate = (input) => {  
      try {
        // 연도, 월, 일, 시, 분, 초를 추출
        const year = input.substring(0, 4);
        const month = input.substring(4, 6);
        const day = input.substring(6, 8);
        const hour = input.substring(8, 10);
        const minute = input.substring(10, 12);
        const second = input.substring(12, 14);
    
        // 변환된 문자열 반환
        return `${year}년 ${parseInt(month, 10)}월 ${parseInt(day, 10)}일 ${parseInt(hour, 10)}시 ${parseInt(minute, 10)}분 ${parseInt(second, 10)}초`;
      } catch {
        return input;
      }
    }

  return (
    <ReceiptContainer>
      <Content>
        <div style={{ textAlign: "center", marginBottom: "15px" }}>매출전표</div>
        <Divider variant="double" />
        <div>
          <ReceiptRow>
            <span>상 호:</span>
            <span>{receiptData?.company}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>대표:</span>
            <span>{receiptData?.agent}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>주소:</span>
            <span>{receiptData?.addr}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>사업자:</span>
            <span>{receiptData?.businessno}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>전화:</span>
            <span>{receiptData?.telno}</span>
          </ReceiptRow>
        </div>
        <Divider />
        <div>
          <ReceiptRow>
            <span>거래일시:</span>
            <span>{formatDate(receiptData?.appdate)}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>리필기번호: </span>
            <span>{receiptData?.alias}</span>
          </ReceiptRow>
        </div>
        <Divider />
        <div>
          <GridRow>
            <span>제품명(종류)</span>
            <span>수량</span>
            <span>단가</span>
            <span>금액</span>
          </GridRow>
          <Divider />
          <GridRow>
            <span>{receiptData?.detergent}</span>
            <span>1</span>
            <span>{receiptData?.price?.toLocaleString()}</span>
            <span>{receiptData?.price?.toLocaleString()}</span>
          </GridRow>
        </div>
        <Divider />
        <div>
          <ReceiptRow>
            <span>공급가:</span>
            <span>{receiptData?.net?.toLocaleString()}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>부가세:</span>
            <span>{receiptData?.vat?.toLocaleString()}</span>
          </ReceiptRow>
        </div>
        <Highlight>
          <span>합계: </span>
          <span>{receiptData?.price?.toLocaleString()}</span></Highlight>
        <Divider />
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          ***신용카드 승인정보***
        </div>
        <div>
          <ReceiptRow>
            <span>카드 번호:</span>
            <span>{receiptData?.cardno}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>카드사:</span>
            <span>{receiptData?.cardname}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>매입사:</span>
            <span>{receiptData?.buyname}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>승인금액:</span>
            <span>{receiptData?.price?.toLocaleString()}</span>
          </ReceiptRow>
          <ReceiptRow>
            <span>승인번호:</span>
            <span>{receiptData?.appno}</span>
          </ReceiptRow>
        </div>
      </Content>
    </ReceiptContainer>
  );
};

export default Receipt;
